import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  HostListener,
  AfterViewInit,
  ElementRef
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import { RackDataService } from "../../data-services/rack.service";
import { RequisitionDataService } from "../../data-services/requisition.service";
import { LookupService } from "../../data-services/lookup.service";
import { RequisitionIntakeDataService } from "../../data-services/requisitionIntake.service";
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BlockUIModule } from 'primeng/blockui';
import { NgxBarcode6 } from 'ngx-barcode6';
import { ScrollerModule } from 'primeng/scroller';
import { RackLocationPipe } from "../../helpers/rackLocation.pipe";
import { DatePipe } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: "app-resolve-unload-rack",
  styleUrls: ["./rack.unload.css"],
  templateUrl: "./rack.unload.html",
  providers: [MessageService],
  imports: [ButtonModule, Dialog, FormsModule, Toast, CommonModule, RadioButtonModule, BlockUIModule, NgxBarcode6, ScrollerModule, RackLocationPipe, DatePipe, ProgressSpinnerModule]
})
export class RackUnloadComponent implements OnInit, AfterViewInit {


  constructor(private rackDataService: RackDataService,
    private requisitionService: RequisitionDataService,
    private lookupService: LookupService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private requisitionIntakeService: RequisitionIntakeDataService
  ) {
  }

  queryParams = "";
  loading = false;
  trackingId = "";
  rack: any = {};
  emptyRack: any = {};
  rackFound = false;
  rackTypes: any[];
  departments: any[];
  searchTrackingHelpText = "";
  showCantLoadDialog = false;
  showNewRackDialog = false;
  cantLoad = false;
  loadMessage = "";
  dialogHeading = "";
  currentRowIndex = 0;
  currentColIndex = 0;
  rackIsFull = false;

  showSpinner = false;
  columnName: string[] = [
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W",
    "X", "Y", "Z"
  ];
  showSpecimenSelectDialog: boolean;
  @ViewChild("rebarCode")
  newSerialBox;
  @ViewChild("searchTracking")
  searchElement: ElementRef;
  @Output()
  onCompleted = new EventEmitter<boolean>();

  ngOnInit() {
    this.rackDataService.getEmptyModel().subscribe((data: any) => {
      this.emptyRack = data;
    });

    this.rackDataService.getRackTypes().subscribe((data: any) => {
      this.rackTypes = data.map(d => <any>{ name: d.Name, code: d.Code });
    });

    this.lookupService.getDepartments().subscribe((data: any) => {
      this.departments = data.map(d => <any>{ name: d.Name, code: d.Id });
    });
    this.searchTrackingHelpText = "Scan rack serial number";
    this.route.paramMap.subscribe(params => {
      this.queryParams = params.get("serial");
      if (this.queryParams) {
        this.loadRack(this.queryParams);
      }
    });
    this.getSpecimenTypes();
  }

  ngAfterViewInit() {
    this.searchElement.nativeElement.focus();
  }

  close() {
    this.onCompleted.emit(false);
  }

  cancel() {
    this.trackingId = "";
  }

  //Barcode scanning/entry handling
  barcode = "";
  barcodeReading = false;

  @HostListener("document:keypress", ["$event"])
  handleScannerInput(event) {
    this.handleKeystroke(event.keyCode, event.key);
  }

  handleKeystroke(keyCode, key) {
    //usually scanners throw an 'Enter' key at the end of read
    if (keyCode === 13) {
      this.handleBarCode(this.barcode);
      this.barcode = "";
    } else {
      this.barcode += key; //while this is not an 'enter' it stores the every key            
    }

    //run a timeout of 200ms at the first read and clear everything
    if (!this.barcodeReading) {
      this.barcodeReading = true;
      setTimeout(() => {
          this.barcode = "";
          this.barcodeReading = false;
        },
        200);
    }
  }

  handleBarCode(code: string) {
    let id = code.replace(/[^ -~]+/g, ""); //remove nondisplayable characters
    if (!id) {
      return;
    }
    id = id.toUpperCase().trim();
    this.loadRack(id);
    this.trackingId = "";
  }

  handleSearchButton() {
    this.handleBarCode(this.trackingId);
  }

  currentTrackingId;

  private loadRack(trackingId: string) {
    this.currentTrackingId = trackingId;
    this.loading = true;
    this.showNewRackDialog = false;
    this.rackDataService.getBySerialNumber(trackingId).subscribe((data: boolean) => {
      console.log('rack', data);
        if (data) {
          this.rack = data;
          this.rack.Contents = this.rack.Contents.sort((n1, n2) => {
            if (n1.Row > n2.Row) return 1;
            if (n1.Row < n2.Row) return -1;
            if (n1.row == n2.Row && n1.Col > n2.Col) return 1;
            if (n1.row == n2.Row && n1.Col < n2.Col) return -1;
            return 0;
          });
          this.loading = false;
          this.searchTrackingHelpText = "Scan accession number";
        } else {
          this.rack = this.emptyRack;
          this.messageService.add({
            severity: "error",
            summary: "Unload Rack",
            detail: `Could not find rack: ${trackingId}`,
            life: 6000,
            closable: true,
            sticky: true
          });
          this.loading = false;
          this.searchTrackingHelpText = "Scan rack serial number";
        }
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Unload Rack",
          detail: `Error looking for Serial Number: ${trackingId}`,
          life: 6000,
          closable: true,
          sticky: true
        });
        this.loading = false;
        this.searchTrackingHelpText = "Scan rack serial number";
      });
  }

  clearCell() {
    this.currentRowIndex = 0;
    this.currentColIndex = 0;
    this.showCantLoadDialog = false;
  }

  changeRack() {
    this.rack = {};
    this.rackIsFull = false;
    this.currentRowIndex = 0;
    this.currentColIndex = 0;
    this.showCantLoadDialog = false;
    this.searchTrackingHelpText = "Scan rack serial number";
  }

  saveLocation(requisitionId) {
    this.loading = true;
    const dto: any = {};
    dto.RackId = this.rack.Id;
    dto.RequisitionId = requisitionId;
    dto.Row = 0;
    dto.Col = 0;
    dto.AddOrRemove = "R";
    var accession = this.rack.Contents.find(x => x.RequisitionId == requisitionId).Accession;

    this.rackDataService.saveRequisitionLocation(dto).subscribe((data: boolean) => {
        this.rack.Contents = this.rack.Contents.filter(x => x.RequisitionId != requisitionId);
        this.loading = false;
      },
      (err) => {
        this.showCantLoadDialog = false;
        this.messageService.add({
          severity: "error",
          summary: "Save Rack Location",
          detail: `Error saving requisition in rack location. Accession: ${accession}`,
          life: 6000,
          closable: true,
          sticky: true
        });
        this.loading = false;
      });
  }

  getColor(x, y) {
    const cell = this.rack.Contents.find(r => r.Row == x + 1 && r.Col == y + 1);
    if (cell) {
      if (cell.StatusText == "Exceptions") return "#ffe38e";
      if (cell.StatusText == "Rejected") return "#dc3545";
      return "#8DC8B5";
    }
    return "lightgrey";
  }

  getAccession(x, y) {
    const cell = this.rack.Contents.find(r => r.Row == x + 1 && r.Col == y + 1);
    if (cell) {
      return cell.Accession;
    }
    return "";
  }

  removeToast() {
    this.messageService.clear();
  }

  order: any = {};
  newSerial: any;
  newSerialVerified: boolean;
  newLabelApplied = false;
  printLabelOption = false;
  showDuplicateDialog = false;
  currentRequisitionId;

  saveOrder() {
    this.showSpinner = true;
    this.requisitionService.saveRequisition(this.order).subscribe(() => {
        if (!this.order.HasExceptions && !this.order.IsNotViable) {
          this.saveLocation(this.currentRequisitionId);
        } else {
          this.loadRack(this.currentTrackingId);
        }
      },
      (err) => {
        this.showSpinner = false;
        this.messageService.add({
          severity: "error",
          summary: "Saving Sample",
          detail: `Error saving sample. Please try again: ${err.error.ExceptionMessage}`,
          life: 10000
        });

      },
      () => { this.showSpinner = false; }
    );
  }

  validateOrder(requisitionId) {
    this.currentRequisitionId = requisitionId;
    const accession = this.rack.Contents.find(x => x.RequisitionId == requisitionId).Accession;

    this.requisitionService.getRequisitionForAccession(accession).subscribe((data: any) => {
      this.order = data;
      this.order.SpecimenTypeMatch = true;
      this.order.NameMatch = null;
      this.order.BirthDateMatch = null;
      this.order.PatientSampleObserved = null;
      this.requisitionService.isPastStability(accession).subscribe((data: boolean) => {
        if (data) {
          this.order.IsNotViable = true;
          this.order.IsRejected = true;
          this.saveOrder();
        } else {
          this.showNameConfirmDialog = true;
        }
      });
    });
  }

  showDupDialog(accession) {
    this.order.Status = "Received";

    this.order.HasExceptions = true;
    this.order.SpecimenSerialNumber = accession;
    this.showDuplicateDialog = true;
    setTimeout(() => {
        this.newSerialBox.nativeElement.focus();
      },
      200);
  }


  cancelDuplicateDialog() {
    this.showDuplicateDialog = false;
    this.showNameConfirmDialog = false;
  }

  closeDuplicateDialog() {
    this.order.Accession = this.newSerial;
    this.order.StatusLevel = 2;
    this.newSerial = null;
    this.newSerialVerified = null;
    this.newLabelApplied = true;
    this.saveOrder();

    this.showDuplicateDialog = false;
  }

  showNameConfirmDialog = false;

  closeNameConfirmDialog() {
    let exceptionMessage = "";
    this.order.Exception = null;
    this.order.IsPatientSampleMismatch = false;
    this.order.IsPatientMismatch = false;
    this.order.HasExceptions = false;


    if (this.order.NameMatch === false && this.order.BirthDateMatch === false) {
      if ( this.order.SpecimenTypeMatch === false) {
        this.order.IsPatientSampleMismatch = true;
      }
      var orderSource = this.order.OrderSource;
      var dateReceived = this.order.DateReceived;
      this.order.Accession = null;
      this.order.Id = 0;
      this.order.SpecimenSerialNumber = null;
      this.order.DateReceived = dateReceived != null ? dateReceived : `${new Date()}`;
      this.order.OrderSource = orderSource;
      this.order.IsPatientMismatch = true;
      this.order.HasExceptions = true;
      this.showDupDialog(this.order.Accession);
    }
    else if (this.order.SpecimenTypeMatch === false) {
      this.order.IsPatientSampleMismatch = true;
      this.order.HasExceptions = true;
    } else {
      this.saveOrder();
    }
    this.showNameConfirmDialog = false;
  }

  cancelNameConfirmDialog() {
    this.showNameConfirmDialog = false;
    this.order = {};
  }

  specimenTypes: any[] = null;

  getSpecimenTypes() {
    this.lookupService.getSpecimenTypes().subscribe((data: any) => {
      this.specimenTypes = data;
    });
  }


  changeSpecimenType(event: any) {
    this.order.PatientSampleObserved = null;
    if (!this.order.SpecimenTypeMatch) {
      this.showSpecimenSelectDialog = true;
    }
  }


  closeSpecimenConfirmDialog(isCancel: boolean) {
    this.showSpecimenSelectDialog = false;
    if (isCancel) {
      this.order.PatientSampleObserved = null;
      this.order.SpecimenTypeMatch = true;
    }
  }

  specimensAvailableList() { return this.specimenTypes?.filter(item => item.Code !== this.order.SpecimenTypeCode) };


  getSpecimenTypeNameByCode(code: string) {
    const specimenType = this.specimenTypes?.find(x => x.Code === code);
    return specimenType?.Name;
  }

  isNextDisabled(): boolean {
    const specimenTypeValid = (this.order.SpecimenTypeMatch === false && this.order.PatientSampleObserved !== null) || this.order.SpecimenTypeMatch === true;
    const x = !(this.order.NameMatch != null &&
      this.order.BirthDateMatch != null && specimenTypeValid
    );
    return x;
  }

  verifyNewAccession() {
    this.requisitionIntakeService.canAccessionBeUsed(this.newSerial).subscribe((data: any) => {
        if (data) {
          this.newSerialVerified = true;
          this.closeDuplicateDialog();
        } else {
          this.newSerial = "";
          this.newSerialVerified = false;
        }
      },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Verify New Serial",
          detail: "Error verifying serial number. Please try again"
        });
        this.newSerialVerified = false;
      });
  }

}
